import { State } from '@/store/index';
import { Module } from 'vuex';
import {
  PartnerApi,
  PartnerRead,
  PartnersGetCollection200Response,
} from '@/api';
import axios from 'axios';

function getPartnerApi(): PartnerApi {
  return new PartnerApi(undefined, import.meta.env.VITE_PROXY_URL, axios);
}

const getDefaultState = () => ({
  partner: {} as PartnerRead,
});

export type partnerState = ReturnType<typeof getDefaultState>;

export const Partner: Module<partnerState, State> = {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    setPartner(state, response: PartnersGetCollection200Response) {
      state.partner = response['hydra:member'][0];
    },
  },

  actions: {
    async fetchPartner({ commit }) {
      const partnerApi = getPartnerApi();
      const response = await partnerApi.partnersGetCollection();
      commit('setPartner', response.data);
    },
  },
};
